import { Injectable } from '@angular/core';
import { BaseViewConfigService, BuyBtnMatrixComponent, Product, ProductViewType } from 'gung-standard';
import { CultBuyBtnComponent } from '../components/cult-buy-btn/cult-buy-btn.component';

@Injectable({
  providedIn: 'root'
})
export class CultBaseViewConfigService extends BaseViewConfigService {
  productViewType: ProductViewType = ProductViewType.productV2;

  getBuyButtonComponent(product: Product): any {
    if (product.productType === 'multiDimension') {
      return BuyBtnMatrixComponent;
    } else {
      return CultBuyBtnComponent;
    }
  }
}
